export default {"src":"/_next/static/media/chevron-down-black.f0f8bd42.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};